// extracted by mini-css-extract-plugin
export default {"title":"da4ecb1c89","inner_title":"_866635ebb0","charge_btn":"_6cc11cbca5"};